import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';

import { SeoService } from '@rpgc-ai/services/seo/seo.service';
import { LanguageService } from '@rpgc-ai/services/translate/language.service';

import type { ICharacter } from '@rpgc-ai/shared-interfaces/interfaces/characters.interface';

import { catchError, map, of, tap } from 'rxjs';

export const chatbotSeoResolver: ResolveFn<void> = (route) => {
  const http = inject(HttpClient);
  const seoService = inject(SeoService);
  const languageService = inject(LanguageService);

  const botId = route.params['botId'];
  if (!botId) {
    return;
  }

  const creatorSlug = route.params['creatorSlug'];
  const characterUrl = creatorSlug ? `${creatorSlug}/${botId}` : botId;

  const lang = languageService.getCurrentLanguage().toUpperCase();

  return http.get<ICharacter>(`characters/${characterUrl}`).pipe(
    tap((character) => {
      const title = `${character.name} | CAICHAT`;
      const descriptions = character.descriptions ?? {};
      const description = descriptions[lang] ?? descriptions['EN'] ?? Object.values(descriptions)[0] ?? '';

      seoService.setTitle(title);
      seoService.setTag('description', description, 'name');
      seoService.setTag('og:title', title, 'property');
      seoService.setTag('og:description', description, 'property');
    }),
    map(() => void 0),
    catchError((error: unknown) => {
      // eslint-disable-next-line no-console
      console.error('chatbotSeoResolver: failed to load chatbot SEO data', error);
      return of(void 0);
    }),
  );
};
